'use client';

import { useEffect, useRef, PropsWithChildren } from 'react';

type HeightTrackerContainerProps = PropsWithChildren<{ className?: string }>;

export const HeightTrackerContainer = ({
  children,
  className,
}: HeightTrackerContainerProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = ref.current;

    if (!container) {
      return;
    }

    const updateMinHeight = () => {
      const currentCard = container.querySelector(
        '[data-expanded=true] .how-to-tabs-card'
      );

      if (!currentCard) {
        return;
      }

      const cardHeight = currentCard.getBoundingClientRect().height;

      container.style.minHeight = `${cardHeight}px`;
    };

    updateMinHeight();

    container.addEventListener('click', updateMinHeight);

    return () => {
      container.removeEventListener('click', updateMinHeight);
    };
  }, []);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
